import { useState } from 'react';
import { submitExchange } from '@/service/service-renewal';
import type { AddressFormData, MysteryBoxGift, SubmitExchangeResult } from './types';

interface SubmitParams extends AddressFormData {
    sn: string;
    snUrl: string;
    deviceUrl: string;
    campaignId: number;
    userChannel: string;
    recaptchaResponse: string;
}

interface UseAddressSubmitReturn {
    loading: boolean;
    result: SubmitExchangeResult | null;
    prizes: MysteryBoxGift[];
    boxRuleName: string;
    error: string | null;
    submit: (params: SubmitParams, locale: string) => Promise<SubmitExchangeResult | null>;
    reset: () => void;
    resetError: () => void;
}

/**
 * 换新活动提交（包含设备回收地址 + SN），成功后返回盲盒礼品列表
 */
export const useAddressSubmit = (): UseAddressSubmitReturn => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<SubmitExchangeResult | null>(null);
    const [error, setError] = useState<string | null>(null);

    const submit = async (params: SubmitParams, locale: string): Promise<SubmitExchangeResult | null> => {
        setLoading(true);
        setError(null);
        try {
            const res = await submitExchange(params, locale);
            if (res?.code === '0') {
                setResult(res.data);
                return res.data;
            } else {
                setError(res?.message ?? 'Submission failed');
                return null;
            }
        } catch (err: any) {
            setError(err?.message ?? 'Submission failed');
            return null;
        } finally {
            setLoading(false);
        }
    };

    const reset = () => {
        setResult(null);
        setError(null);
    };

    const resetError = () => setError(null);

    return {
        loading,
        result,
        prizes: result?.ruleGiftRespVos ?? [],
        boxRuleName: result?.boxRuleName ?? '',
        error,
        submit,
        reset,
        resetError,
    };
};
